// extracted by mini-css-extract-plugin
export var copyableItem = "_7-0";
export var underlined = "_7-1";